import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox/lib/dialog';
import * as steps from 'common/steps';
import { getStep } from 'common/selectors';
import ResizingIframe from 'general-components/ResizingIframe';
import LoadingPanel from 'general-components/LoadingPanel';
import styles from './OptInTermsDialog.css';
import theme from './OptInTermsDialogTheme.css';

import {
  ACCEPT_OPT_IN,
  DECLINE_OPT_IN,
  SET_TERMS_LOADING,
} from 'options/optionsActions';

import {
  getOptInForId,
  getOptInTermsDialog,
  getOptIns,
} from 'options/optionsReducer';

const OptInTermsDialog = ({
  acceptTitle,
  declineTitle,
  loading,
  onAccept,
  onDecline,
  onTermsLoaded,
  optInId,
  optInName,
  termsUri,
  visible,
}) =>
  <Dialog theme={theme} active={visible} title={optInName}>
    <div className={styles.container}>
      <div className={styles.iframeContainer}>
        <ResizingIframe src={termsUri} onLoad={onTermsLoaded} />
        {loading && <LoadingPanel />}
      </div>
    </div>
    <div className={styles.buttonRow}>
      <Button
        disabled={loading}
        raised
        primary
        onClick={() => onAccept(optInId)}
      >
        {acceptTitle}
      </Button>
      <Button onClick={() => onDecline(optInId)}>
        {declineTitle}
      </Button>
    </div>
  </Dialog>;

const mapState = R.pipe(
  getStep(steps.OPTIONS),
  R.converge(
    (dialog, optIns) => R.merge(dialog, getOptInForId(dialog.optInId, optIns)),
    [getOptInTermsDialog, getOptIns],
  ),
);

const mapDispatch = dispatch => ({
  onAccept: id => dispatch({ type: ACCEPT_OPT_IN, id }),
  onDecline: id => dispatch({ type: DECLINE_OPT_IN, id }),
  onTermsLoaded: () => dispatch({ type: SET_TERMS_LOADING, loading: false }),
});

export default connect(mapState, mapDispatch)(OptInTermsDialog);



// WEBPACK FOOTER //
// ./src/options/components/OptInTermsDialog.js